var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "multiple-19",
    width: 32,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAB3ElEQVRIicXWMWgUURAG4C+HQSsVjKCViFUsDIKFhUKqFGljk1SCXRqxiYIHAbFQMOlsbLSwktQiVsZ0EhRtDDYiiI2ixkqRoCzMQdjbt+8dd+IPy7Iz/7z59/Hm3x3bvnRGCybRxQwm8AVPcRNv2wpL0WnhzeEVFqK5uC9EfC5Rtx8r+IQ/cV+JeB9SOzAZTfa2CPyF07WdqJps4FQD/w3O48fuYGoHupnmIt+txZYTzUV8uR5MCZjJNE/x5jP8vnxKwEQinuMdzfD78ikB3woF1HmfM/y+fErA80IBdd6TDL8vnxJwr1BAnXcHOwnuTuSLBDyOqw1NnGrUlhI1S5EvEiAMZzOR24x8E1YjtxVGtBXPq03knBXvwzVcxDF8wAPcws+2wlLkBPxz7Blhg0O4jHNh5Uci/js+Yu/wIiZhvXdYm3bgAGbDtyuvP46DYb2V/3/H+/hWbMRB3I7as3iIExmxH3EFa7sFTOEqLmB8gDev3nANt/Eah/EMJwtqZ3tTsIiX4dWDNBf8+ahfDLebC2E53KgETONuZiRL0Il1pmP07hfUTFVF14dsXEdvvUcF3PFOHLZRorden+s1oVPw4zEoeut9LakbpQ/UUc35WI407MEbGv9XAP4CkPNeCJNbJrwAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b27ff3d381ce8b831d82a339b697adb2.svg";
export { ForwardRef as ReactComponent };